angular.module('bmsApp.user')
	.controller('LogoutCtrl', function ($scope, $rootScope, AuthService, notificationService, $location, $localStorage) {
		$localStorage.currentInstance = undefined;
		$rootScope.$broadcast('authLogOut');
		AuthService.logout();
	});
